import { z } from 'zod';
import { FileDataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/file-data-set-config';
import { SupplementalDataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/supplemental-data-set-config';
import { IntegrationDataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/integration-data-set-config';
import { CompositeDataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/composite-data-set-config';

export const DataSetConfig = z.union([
  SupplementalDataSetConfig,
  IntegrationDataSetConfig,
  FileDataSetConfig,
  CompositeDataSetConfig,
]);

export type DataSetConfig = z.infer<typeof DataSetConfig>;

export const DataSetPostProcessingSettings = z.object({
  runOnBatch: z.boolean().optional(),
});

export type DataSetPostProcessingSettings = z.infer<
  typeof DataSetPostProcessingSettings
>;

export const DataSet = z.object({
  id: z.string(),
  /** The display name of the data set */
  displayName: z.string(),
  /** The config of the data set which includes information such as
   * the integration type and the data set type, etc.
   */
  config: DataSetConfig,

  /**
   * The post processing settings for the data set,
   * such as whether to run the post processing on batch instead of lambda.
   */
  postProcessingSettings: DataSetPostProcessingSettings.optional(),

  isArchived: z.boolean().default(false),
});

export type DataSet = z.infer<typeof DataSet>;

export const DataSetWithExternalMergeData = DataSet.extend({
  externalMergeLink: z.string().optional(),
});

export type DataSetWithExternalMergeData = z.infer<
  typeof DataSetWithExternalMergeData
>;
